import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getExtraServiceGroupListSaga = createAction(
  "GET_EXTRA_SERVICE_GROUP",
  ({ payload, params }: SagaActionParams<Type.ExtraServiceGroupDto[]>) => ({
    payload,
    url: "/api/admin/adminextraservicegroup" + (params ? params : ""),
  })
);
export const getExtraServiceGroupDetailsSaga = createAction(
  "GET_EXTRA_SERVICE_GROUP_DETAILS",
  ({ payload, id }: SagaActionParams<Type.ExtraServiceGroupDetailDto>) => ({
    payload,
    url: "/api/admin/adminextraservicegroup/" + id,
  })
);
export const createExtraServiceGroupSaga = createAction(
  "CREATE_EXTRA_SERVICE_GROUP",
  ({ payload, body }: SagaActionParams<Type.ExtraServiceGroupDto>) => ({
    payload,
    url: "/api/admin/adminextraservicegroup",
    body,
  })
);
export const updateExtraServiceGroupSaga = createAction(
  "UPDATE_EXTRA_SERVICE_GROUP",
  ({ payload, id, body }: SagaActionParams<Type.ExtraServiceGroupDto>) => ({
    payload,
    url: "/api/admin/adminextraservicegroup/" + id,
    body,
  })
);
export const deleteExtraServiceGroupSaga = createAction(
  "DELETE_EXTRA_SERVICE_GROUP",
  ({ payload, id }: SagaActionParams<Type.ExtraServiceGroupDto>) => ({
    payload,
    url: "/api/admin/adminextraservicegroup/" + id,
  })
);

const extraServiceGroupSaga = [
  takeLatest<any>(
    getExtraServiceGroupListSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceGroupDto[]>) =>
      getSaga<Type.ExtraServiceGroupDto[]>(payload)
  ),
  takeLatest<any>(
    getExtraServiceGroupDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceGroupDetailDto>) =>
      getSaga<Type.ExtraServiceGroupDetailDto>(payload)
  ),
  takeLatest<any>(
    createExtraServiceGroupSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceGroupDto>) =>
      postSaga<Type.ExtraServiceGroupDto>(payload)
  ),
  takeLatest<any>(
    updateExtraServiceGroupSaga.toString(),
    (payload: SagaGenericParams<Type.ExtraServiceGroupDto>) =>
      putSaga<Type.ExtraServiceGroupDto>(payload)
  ),
  takeLatest<any>(
    deleteExtraServiceGroupSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.ExtraServiceGroupDto>(payload)
  ),
];

export default extraServiceGroupSaga;
